<template>
  <b-col 
    class="px-4 mt-3 mx-auto" 
    cols="12" md="10" lg='8'
  >
    <form 
      class="change-mail-form p-2 m-2" 
      @submit.prevent="changeEmail" 
      novalidate
    >
      <h4 class="mb-3 form-header">{{'userProfileChengeEmailHeader' | localize}}:</h4>
      <div class="new-address-description ">{{'userProfileChangeEmailNewHeader' | localize}}:</div>
      <input 
        v-model="new_mail"
        type="email"
        class="form-control"
      >
      <div 
          class="form-description"
          v-if="!$v.new_mail.$dirty && !$v.new_mail.required"
      >
          {{'userProfileChangeEmailNewDescription' | localize}}
      </div>
      <div 
          class="form-description-error"
          v-if="$v.new_mail.$dirty && !$v.new_mail.required"
      >
          {{'newAddressRequiredInput' | localize}}
      </div>
      <div 
          class="form-description-error"
          v-if="$v.new_mail.$dirty && !$v.new_mail.email"
      >
          {{'userProfileChangeEmailNewDescription' | localize}}
      </div>
      <div class="new-address-description ">{{'userProfileChengeCurrentPass' | localize}}:</div>
      <input 
          type="password" 
          class="form-control"
          v-model="user_pass"
      >
      <div 
          class="form-description-error"
          v-if="$v.user_pass.$dirty && !$v.user_pass.required"
      >
          {{'newAddressRequiredInput' | localize}}
      </div> 
      <b-button 
        class="my-3 style-button button-profile"
        type="submit"
        variant="outline-danger"
      >
        {{'userProfileButton' | localize}} 
        <div class="style-button-icon"> 
          <b-icon  icon="mailbox" ></b-icon> 
        </div> 
      </b-button>
    </form>

  </b-col>  
</template>
<script>
import base64url from "base64url";
import { mapGetters } from 'vuex'
import { validationMixin } from 'vuelidate'
import { required, email } from 'vuelidate/lib/validators'
export default {
  mixins: [validationMixin],
  data: ()=> ({
    new_mail: '',
    user_pass: '',
  }),
  validations: {
      new_mail: {required, email},
      user_pass: {required},
  },
  mounted(){
    this.new_mail = localStorage.weltum_user_mail
  },
  computed: mapGetters(['userInfo_data', 'locale']),
  methods: {
    async changeEmail(){
      if(this.$v.$invalid){
        this.$v.$touch()
      } else {
        const PASS = base64url.decode(localStorage.weltumPass )
        if(this.user_pass === PASS){
          const user = {
              login: localStorage.weltumAuth,
              password: PASS,
              fio: localStorage.weltum_user_fio,
              tel: localStorage.weltum_user_tel, 
              mail: this.new_mail,
              secret_key: localStorage.weltumKey
          }
          await this.$store.dispatch('changeUserData', user )
          if(this.userInfo_data.msg === 'OK'){
            this.$messageLocalized('dataChanged')
            localStorage.setItem('weltum_user_mail', this.new_mail) 
            this.user_pass = '';
          }
        } else if (this.user_pass !== PASS) {
          this.$messageLocalized('wrongPassword')
        }

      }       
    },
  }
  
}
</script>
